import React from "react";

/**
 * HOC that conditionally renders the WrappedComponent as an overlay.
 * @param {Component} WrappedComponent - The component to render as an overlay.
 * @returns {Component} - The enhanced component.
 */
const withOverlay = (WrappedComponent) => {
  return function OverlayComponent({
    isOpen,
    onResult,
    closeOverlay,
    ...props
  }) {
    if (!onResult) {
    }
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <WrappedComponent
          {...props}
          onResult={onResult}
          closeOverlay={closeOverlay}
        />
      </div>
    );
  };
};

export default withOverlay;
